export default __webpack_public_path__ + "static/media/scatter-chart-icon.d2d512d3.png";